import { render, staticRenderFns } from "./StatsUnitsPerEmployee.vue?vue&type=template&id=78e0bfa8&"
import script from "./StatsUnitsPerEmployee.vue?vue&type=script&lang=js&"
export * from "./StatsUnitsPerEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78e0bfa8')) {
      api.createRecord('78e0bfa8', component.options)
    } else {
      api.reload('78e0bfa8', component.options)
    }
    module.hot.accept("./StatsUnitsPerEmployee.vue?vue&type=template&id=78e0bfa8&", function () {
      api.rerender('78e0bfa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity-flash/reports/StatsUnitsPerEmployee.vue"
export default component.exports